/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 1 = Bid

2 = Allowance

3 = Bid and Allowance

-1 = None


 */
export type MarkedAs = (typeof MarkedAs)[keyof typeof MarkedAs];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarkedAs = {
  Bid: 1,
  Allowance: 2,
  LegacyBidAllowance: 3,
  None: -1,
} as const;
